import { render, staticRenderFns } from "./HistoryItem.vue?vue&type=template&id=086d2cc6&"
import script from "./HistoryItem.vue?vue&type=script&lang=js&"
export * from "./HistoryItem.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('086d2cc6')) {
      api.createRecord('086d2cc6', component.options)
    } else {
      api.reload('086d2cc6', component.options)
    }
    module.hot.accept("./HistoryItem.vue?vue&type=template&id=086d2cc6&", function () {
      api.rerender('086d2cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/hotsugg/components/HistoryItem.vue"
export default component.exports